import React, { FC } from 'react';
import { UnsettledDigitalBillDto } from '../../../../../types/digitalBill';
import FormattedMessage from '../../../../../components/FormattedMessage';
import { Checkbox } from '@ordr-as/umami-react/checkbox';
import { useLocation } from '../../../../../context/LocationContext';
import useIntl from '../../../../../hooks/useIntl';

interface Props {
  existingBill: UnsettledDigitalBillDto;
  confirmUseExistingBill: boolean;
  setConfirmUseExistingBill: (value: boolean) => void;
}

const ExistingTableWarning: FC<Props> = ({ existingBill, confirmUseExistingBill, setConfirmUseExistingBill }) => {
  const { formatCurrency } = useLocation();
  const tableNumber = existingBill.primaryReference;
  const intl = useIntl();
  return (
    <>
      {tableNumber && (
        <p className="text-orange-darkest text-xs">
          <FormattedMessage id="digitalBill.tableExists" values={{ tableNumber: tableNumber }} />
        </p>
      )}
      <p className="text-grey-dark text-xs">{intl.formatMessage({ id: `digitalBill.tableExists.protip` })}</p>
      <div className="bg-grey-lightest rounded pl-2">
        <Checkbox isSelected={confirmUseExistingBill} onChange={setConfirmUseExistingBill}>
          <div className="bg-grey-lightest rounded p-2">
            <FormattedMessage id="digitalBill.tableExists.confirmLabel" values={{ tableNumber: tableNumber }} />
            <p className="text-grey-dark text-xs mt-1">
              <FormattedMessage
                id="digitalBill.tableExists.tableStatus"
                values={{
                  updated: new Date(existingBill.updated).toLocaleTimeString('en-GB', {
                    hour: 'numeric',
                    minute: 'numeric',
                  }),
                  sum: formatCurrency(existingBill.sum),
                }}
              />
            </p>
          </div>
        </Checkbox>
      </div>
    </>
  );
};

export default ExistingTableWarning;
